import { notificationCenter } from "./routes/components/notification-center/reducers";
import merge from "lodash/merge";
import _ from "lodash";
import auth from "./routes/auth/reducers";
import users from "./routes/users/reducers";
import clinics from "./routes/clinics/reducers";
import districts from "./routes/districts/reducers";
import services from "./routes/services/reducers";
import games from "./routes/games/reducers";
import clinical_content from "./routes/clinical_content/reducers";
import treatment from "./routes/treatment/reducers";

// Updates an entity cache in response to any action with response.entities.
const initialState = {
  users: {},
  clinics: {},
  districts: {},
  students: {},
  therapists: {},
  treatments: {},
  services: {},
};

const entities = (state = initialState, action) => {
  const value = _.get(action, "payload.response.entities");
  const isReset = _.get(action, "payload.reset");
  if (value) {
    const newState = { ...state };
    if (isReset) {
      const resetKey = _.get(action, "payload.resetKey");
      delete newState[resetKey];
    }
    return merge({}, newState, value);
  }
  return merge({}, state);
};

const rootReducer = {
  entities,
  notificationCenter,
  auth,
  users,
  clinics,
  districts,
  services,
  clinical_content,
  treatment,
  games,
};

export default rootReducer;
